export default {
      id: "logo-usage",
      viewBox: "0 0 490 146",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }